//
//
//
//
//
//
//
//
//
//
//
//

import AccountList from "@/components/Query/AccountList";
export default {
  name: "Account",
  data() {
    return {};
  },
  components: { AccountList },
  filters: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
